import { withContext } from '@hilma/tools';

import { SocketContext } from '../SocketProvider';
import { HilmaSocket } from '../types';

/**
 * Higher Order Component that injects the socket via the `socket` prop
 * @param Component The component you want to pass the socket to
 */
const withSocket = withContext({ socket: SocketContext as React.Context<HilmaSocket> });

export default withSocket;